import { Box, CircularProgress, Grid } from '@mui/material';
import * as React from 'react';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import SearchHierarchy from 'src/components/layouts/DashboardLayout/SearchHierarchy';
import { AppState, useAppSelector } from 'src/store';
import DocumentViewerComponent from '../documentViewer/DocumentViewer';
import DocumentStatusOverTimeComponent from './documentStatusOverTime/DocumentStatusOverTimeComponent';
import './landing.scss';
import MostRecentDocsComponent from './recentDocuments/MostRecentDocsComponent';
import StudyCompletenessComponent from './studyCompleteness/StudyCompletenessComponent';
import { useGetStudiesQuery } from 'src/components/Services/Utils';

/**
 * Landing page container.
 *
 * @param props Props from parent view.
 * @returns Landing page container component.
 */
const LandingViewContainer = (props: any) => {
  const [dataGridComponent, setDataGridComponent] = React.useState(true);
  const [documentToDisplay, setDocumentToDisplay] = React.useState<any>();

  const SearchHierarchyDetail: any = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]);
  const isDataAvailable: any = useAppSelector(state => state.user.user?.userdataavailable);

  const [isfLevelValue, setIsfLevelValue] = React.useState<string>('Site');

  const [studyValue, setStudyValue] = React.useState<string>(
    SearchHierarchyDetail?.Study ? SearchHierarchyDetail?.Study : '--'
  );

  const [previousStudyValue, setPreviousStudyValue] = React.useState<string>(
    SearchHierarchyDetail?.Study ? SearchHierarchyDetail?.Study : '--'
  );

  const [countryValue, setCountryValue] = React.useState<string>(
    SearchHierarchyDetail?.Country ? SearchHierarchyDetail?.Country : '--'
  );

  const [siteValue, setSiteValue] = React.useState<string>(
    SearchHierarchyDetail?.Site ? SearchHierarchyDetail?.Site : '--'
  );

  /**
   * Get the selection hierarchy data based on study, country and site.
   *
   * @param study  Selected study.
   * @param country  Selected country.
   * @param site  Selected site.
   */
  const getHierarchicalData = async (study = '--', country = '--', site = '--') => {
    if (study !== studyValue) {
      setPreviousStudyValue(studyValue);
      setStudyValue(study);
    }
    if (country !== countryValue) {
      setCountryValue(country);
    }
    if (site !== siteValue) {
      setSiteValue(site);
    }
    let IsfLevel =
      (study === '--' || study === '') && (country === '--' || country == '') && (site === '--' || site === '')
        ? '--'
        : (country === '--' || country == '') && (site === '--' || site === '')
        ? 'Study'
        : site === '--' && country != '--'
        ? 'Country'
        : 'Site';
    if (IsfLevel === '--') {
      IsfLevel = 'Study';
    }
    setIsfLevelValue(IsfLevel);
  };

  useEffect(() => {
    getHierarchicalData(SearchHierarchyDetail?.Study, SearchHierarchyDetail?.Country, SearchHierarchyDetail?.Site);
    if (dataGridComponent || props.onClicked) {
      props.routeInfo && props.routeInfo('');
      setDataGridComponent(true);
    } else {
      props.routeInfo && props.routeInfo('landing');
    }
  }, [dataGridComponent, props.onClicked, SearchHierarchyDetail]);

  const { isLoading, data: studyData, isError, isSuccess, refetch: getStudyList } = useGetStudiesQuery();

  return (
    <React.Fragment>
      {dataGridComponent ? (
        <div>
          <SearchHierarchy searchData={getHierarchicalData} />
          {isLoading ? (
            <Box sx={{ display: 'flex', height: '70vh', alignItems: 'center', justifyContent: 'center' }}>
              <CircularProgress />
            </Box>
          ) : (
            <>
              {isDataAvailable != null && isDataAvailable === false && isError ? (
                <div className="no-data-class">
                  <h3>No Data access available!</h3>
                </div>
              ) : (
                <>
                  <Box className="resultBox">
                    <div style={{ height: '80vh', width: '100%' }}>
                      <StudyCompletenessComponent
                        IsfLevel={isfLevelValue}
                        study={studyValue}
                        country={countryValue}
                        site={siteValue}
                      />
                      <DocumentStatusOverTimeComponent
                        study={studyValue}
                        previousStudyValue={previousStudyValue}
                        country={countryValue}
                        site={siteValue}
                      />
                      <Grid container sx={{ mt: 0, mb: 1 }} spacing={2}>
                        <Grid item xs={12} md={12}>
                          <MostRecentDocsComponent
                            dataGridComponent={setDataGridComponent}
                            documentToDisplay={setDocumentToDisplay}
                            study={studyValue}
                            previousStudyValue={previousStudyValue}
                            country={countryValue}
                            site={siteValue}
                          />
                        </Grid>
                      </Grid>
                    </div>
                  </Box>
                </>
              )}
            </>
          )}
        </div>
      ) : (
        <div>
          {documentToDisplay && (
            <DocumentViewerComponent
              documentDetails={documentToDisplay}
              setDataGridComponent={setDataGridComponent}
              props={props}
            />
          )}
        </div>
      )}
    </React.Fragment>
  );
};

export default LandingViewContainer;
